import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiClient } from '../../services/apiClient';
import { toastService } from '../../services/toastService';

const ORG_PATH = '/app/organization?tab=mcp';

let inFlightKey = null;
let inFlightPromise = null;

export default function MCPOAuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const code = params.get('code');
  const state = params.get('state');
  const oauthError = params.get('error');
  const oauthErrorDescription = params.get('error_description');

  useEffect(() => {
    if (oauthError) {
      setErrorMessage(oauthErrorDescription || oauthError);
      sessionStorage.removeItem('mcpOAuthFlow');
      return;
    }
    if (!code || !state) {
      setErrorMessage('Missing code or state in OAuth redirect');
      return;
    }

    const key = `${code}:${state}`;
    if (inFlightKey !== key || !inFlightPromise) {
      inFlightKey = key;
      inFlightPromise = apiClient
        .completeMcpOAuth({ code, state })
        .finally(() => {
          if (inFlightKey === key) {
            inFlightKey = null;
            inFlightPromise = null;
          }
        });
    }

    let active = true;
    (async () => {
      try {
        await inFlightPromise;
        let serverName = '';
        try {
          const stash = JSON.parse(sessionStorage.getItem('mcpOAuthFlow') || '{}');
          serverName = stash.serverName || '';
        } catch { /* ignore */ }
        sessionStorage.removeItem('mcpOAuthFlow');
        toastService.success(serverName ? `Connected to ${serverName}` : 'MCP server connected');
        if (active) navigate(ORG_PATH, { replace: true });
      } catch (e) {
        if (active) setErrorMessage(e.message || 'OAuth exchange failed');
      }
    })();

    return () => { active = false; };
  }, [code, state, oauthError, oauthErrorDescription, navigate]);

  if (errorMessage) {
    return (
      <div style={{ padding: 32, maxWidth: 600 }}>
        <h2>OAuth connection failed</h2>
        <p>{errorMessage}</p>
        <p>
          <a href={ORG_PATH}>Return to MCP Servers</a>
        </p>
      </div>
    );
  }
  return (
    <div style={{ padding: 32 }}>
      <p>Finalizing OAuth connection…</p>
    </div>
  );
}
